import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import duecollectionService from "./duecollectionService";


const initialState = {
  duecollections: [],
  duecollection: null,

  isCreateLoading: false,
  isCreateError: false,
  isCreateSuccess: false,
  createErrorMessage: "",

  isListLoading: false,
  isListError: false,
  isListSuccess: false,
  listErrorMessage: "",

  isDetailsLoading: false,
  isDetailsError: false,
  isDetailsSuccess: false,
  detailsErrorMessage: "",

  isUpdateLoading: false,
  isUpdateError: false,
  isUpdateSuccess: false,
  updateErrorMessage: "",

  isDeleteLoading: false,
  isDeleteError: false,
  isDeleteSuccess: false,
  deleteErrorMessage: "",

  isListByPassportIdLoading: false,
  isListByPassportIdError: false,
  isListByPassportIdSuccess: false,
  listByPassportIdErrorMessage: "",
};

//Create Duecollection
export const createDueCollection = createAsyncThunk(
  "duecollection/createDueCollection",
  async (duecollection, thunkAPI) => {
    try {
      const token = thunkAPI.getState().user.userInfo.token;
      const createdDuecollection =
        await duecollectionService.createDueCollection(duecollection, token);
      return createdDuecollection;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//Get All Duecollections
export const getAllDueCollections = createAsyncThunk(
  "duecollection/getAllDueCollections",
  async (_, thunkAPI) => {
    try {
      const token = thunkAPI.getState().user.userInfo.token;
      const duecollections = await duecollectionService.getAllDueCollections(
        token
      );
      return duecollections;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//Get Duecollection By Id
export const getDueCollectionById = createAsyncThunk(
  "duecollection/getDueCollectionById",
  async (id, thunkAPI) => {
    try {
      const token = thunkAPI.getState().user.userInfo.token;
      const duecollection = await duecollectionService.getDueCollectionById(
        id,
        token
      );
      return duecollection;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//Update Duecollection
export const updateDueCollection = createAsyncThunk(
  "duecollection/updateDueCollection",
  async (duecollection, thunkAPI) => {
    const { id, duecollectionData } = duecollection;
    try {
      const token = thunkAPI.getState().user.userInfo.token;
      const updatedDuecollection =
        await duecollectionService.updateDueCollection(
          id,
          duecollectionData,
          token
        );
      return updatedDuecollection;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//Delete Duecollection
export const deleteDueCollection = createAsyncThunk(
  "duecollection/deleteDueCollection",
  async (id, thunkAPI) => {
    try {
      const token = thunkAPI.getState().user.userInfo.token;
      await duecollectionService.deleteDueCollection(id, token);
      return id;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get Duecollections By Passport Id
export const getDueCollectionsByPassportId = createAsyncThunk(
  "duecollection/getDueCollectionsByPassportId",
  async (id, thunkAPI) => {
    try {
      const token = thunkAPI.getState().user.userInfo.token;
      const duecollections =
        await duecollectionService.getDueCollectionsByPassportId(id, token);
      return duecollections;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const duecollectionSlice = createSlice({
  name: "duecollection",
  initialState,
  reducers: {
    resetDueCollectionCreate: (state) => {
      state.isCreateLoading = false;
      state.isCreateError = false;
      state.isCreateSuccess = false;
      state.createErrorMessage = "";
    },
    resetDueCollectionList: (state) => {
      state.duecollections = [];
      state.isListLoading = false;
      state.isListError = false;
      state.isListSuccess = false;
      state.listErrorMessage = "";
    },
    resetDueCollectionDetails: (state) => {
      state.duecollection = null;
      state.isDetailsLoading = false;
      state.isDetailsError = false;
      state.isDetailsSuccess = false;
      state.detailsErrorMessage = "";
    },
    resetDueCollectionUpdate: (state) => {
      state.isUpdateLoading = false;
      state.isUpdateError = false;
      state.isUpdateSuccess = false;
      state.updateErrorMessage = "";
    },
    resetDueCollectionDelete: (state) => {
      state.isDeleteLoading = false;
      state.isDeleteError = false;
      state.isDeleteSuccess = false;
      state.deleteErrorMessage = "";
    },
    resetListByPassportId: (state) => {
      state.duecollections = [];
      state.isListByPassportIdLoading = false;
      state.isListByPassportIdError = false;
      state.isListByPassportIdSuccess = false;
      state.listByPassportIdErrorMessage = "";
    }
  },

  extraReducers: (builder) => {
    builder
      .addCase(createDueCollection.pending, (state, action) => {
        state.isCreateLoading = true;
        state.isCreateError = false;
        state.isCreateSuccess = false;
        state.createErrorMessage = "";
      })
      .addCase(createDueCollection.fulfilled, (state, action) => {
        state.isCreateLoading = false;
        state.isCreateError = false;
        state.isCreateSuccess = true;
        state.createErrorMessage = "";

        state.duecollections = [...state.duecollections, action.payload];
        state.duecollection = action.payload;
      })
      .addCase(createDueCollection.rejected, (state, action) => {
        state.isCreateLoading = false;
        state.isCreateError = true;
        state.isCreateSuccess = false;
        state.createErrorMessage = action.payload;
      })
      .addCase(getAllDueCollections.pending, (state, action) => {
        state.isListLoading = true;
        state.isListError = false;
        state.isListSuccess = false;
        state.listErrorMessage = "";
      })
      .addCase(getAllDueCollections.fulfilled, (state, action) => {
        state.isListLoading = false;
        state.isListError = false;
        state.isListSuccess = true;
        state.listErrorMessage = "";

        state.duecollections = action.payload;
      })
      .addCase(getAllDueCollections.rejected, (state, action) => {
        state.isListLoading = false;
        state.isListError = true;
        state.isListSuccess = false;
        state.listErrorMessage = action.payload;
      })
      .addCase(getDueCollectionById.pending, (state) => {
        state.isDetailsLoading = true;
        state.isDetailsError = false;
        state.isDetailsSuccess = false;
        state.detailsErrorMessage = "";
      })
      .addCase(getDueCollectionById.fulfilled, (state, action) => {
        state.isDetailsLoading = false;
        state.isDetailsError = false;
        state.isDetailsSuccess = true;
        state.detailsErrorMessage = "";
        state.duecollection = action.payload;
      })
      .addCase(getDueCollectionById.rejected, (state, action) => {
        state.isDetailsLoading = false;
        state.isDetailsError = true;
        state.isDetailsSuccess = false;
        state.detailsErrorMessage = action.payload;
      })
      .addCase(updateDueCollection.pending, (state) => {
        state.isUpdateLoading = true;
        state.isUpdateError = false;
        state.isUpdateSuccess = false;
        state.updateErrorMessage = "";
      })
      .addCase(updateDueCollection.fulfilled, (state, action) => {
        state.isUpdateLoading = false;
        state.isUpdateError = false;
        state.isUpdateSuccess = true;
        state.updateErrorMessage = "";

        state.duecollections = state.duecollections.map((duecollection) => {
          if (duecollection._id === action.payload._id) {
            return action.payload;
          }
          return duecollection;
        });
        state.duecollection = action.payload;
      })
      .addCase(updateDueCollection.rejected, (state, action) => {
        state.isUpdateLoading = false;
        state.isUpdateError = true;
        state.isUpdateSuccess = false;
        state.updateErrorMessage = action.payload;
      })
      .addCase(deleteDueCollection.pending, (state) => {
        state.isDeleteLoading = true;
        state.isDeleteError = false;
        state.isDeleteSuccess = false;
        state.deleteErrorMessage = "";
      })
      .addCase(deleteDueCollection.fulfilled, (state, action) => {
        state.isDeleteLoading = false;
        state.isDeleteError = false;
        state.isDeleteSuccess = true;
        state.deleteErrorMessage = "";

        state.duecollections = state.duecollections.filter(
          (duecollection) => duecollection._id !== action.payload
        );
        state.duecollection = null;
      })
      .addCase(deleteDueCollection.rejected, (state, action) => {
        state.isDeleteLoading = false;
        state.isDeleteError = true;
        state.isDeleteSuccess = false;
        state.deleteErrorMessage = action.payload;
      })
      .addCase(getDueCollectionsByPassportId.pending, (state) => {
        state.isListByPassportIdLoading = true;
        state.isListByPassportIdError = false;
        state.isListByPassportIdSuccess = false;
        state.listByPassportIdErrorMessage = "";
      })
      .addCase(getDueCollectionsByPassportId.fulfilled, (state, action) => {
        state.isListByPassportIdLoading = false;
        state.isListByPassportIdError = false;
        state.isListByPassportIdSuccess = true;
        state.listByPassportIdErrorMessage = "";

        state.duecollections = action.payload;
      })
      .addCase(getDueCollectionsByPassportId.rejected, (state, action) => {
        state.isListByPassportIdLoading = false;
        state.isListByPassportIdError = true;
        state.isListByPassportIdSuccess = false;
        state.listByPassportIdErrorMessage = action.payload;
      });
  },
});

export const {
  resetDueCollectionCreate,
  resetDueCollectionList,
  resetDueCollectionDetails,
  resetDueCollectionUpdate,
  resetDueCollectionDelete,
} = duecollectionSlice.actions;

export default duecollectionSlice.reducer;
